import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { USER_DATA } from '../constant';
import { Spacing } from '../../../theme';

import { CardElem } from '../../../common/card';

import { TextElem } from '../../../common/text';
import { UserItemUpdateContainer } from '../../../epic/user-item-update';
import { ReactComponent as EditIcon } from '../../../asset/svg/common/edit.svg';
import { ReactComponent as MoreIcon } from '../../../asset/svg/common/more.svg';
import { ContentContainerElem } from '../../../common/content-container';
import { COLOR_ENUM } from '../../../theme/color';
import {
  SIZE_BORDER_RADIUS_DATA,
  SIZE_BORDER_RADIUS_ENUM,
} from '../../../theme/size';
import { DividerElem } from '../../../common/divider';
import { useRef } from 'react';

import { useOnClickOutside } from 'usehooks-ts';
import { UserItemDeleteContainer } from '../../../epic/user-item-delete';
import { ReactComponent as DeleteIcon } from '../../../asset/svg/delete/delete.svg';
import { EllipsisContainerElem } from '../../../common/ellipsis-container';

interface Props extends USER_DATA {
  updateVisible: string | null;
  setUpdateVisible: Function;
}

const Elem: React.FC<Props> = ({
  id,
  email,
  role,
  password,
  createDate,
  setUpdateVisible,
  telegramId,
  name,
  updateVisible,
  project,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const ref = useRef(null);

  const handleClickOutside = () => {
    // Your custom logic here
    setModalVisible(false);
  };

  const closeModalVisible = () => setModalVisible(false);

  const deleteModalOpen = () => {
    setDeleteModalVisible(true);
    setTimeout(() => {
      closeModalVisible();
    });
  };

  const deleteModalClose = () => {
    setDeleteModalVisible(false);
  };

  const handleUpdateVisible = () => {
    setModalVisible(false);
    setUpdateVisible(id);
  };

  const handleCloseModal = () => {
    setUpdateVisible(null);
    setModalVisible(false);
  };

  useOnClickOutside(ref, handleClickOutside);

  const [height, setHeight] = useState(0);
  const updRef = useRef<any>(null);

  useEffect(() => {
    if (updRef.current) {
      setHeight(updRef.current?.offsetHeight);
    }
  }, [updateVisible]);
  return (
    <>
      <Card height={height} updVisible={updateVisible === id} hover={false}>
        {updateVisible === id && (
          <Div ref={updRef}>
            <ContentContainerElem>
              <UserItemUpdateContainer
                data={{
                  createDate,
                  id,
                  email,
                  name,
                  role,
                  password,
                  telegramId,
                  project,
                }}
                close={handleCloseModal}
              />
            </ContentContainerElem>
          </Div>
        )}
        <EllipsisContainerElem style={{ paddingRight: `${Spacing(5)}` }}>
          <TextElem
            tid="USER.ITEM.EMAIL"
            tvalue={{ value: name }}
            type="semi-bold"
            size="main"
            oneLine
          />
        </EllipsisContainerElem>

        <TextElem
          tid="USER.ITEM.ID"
          tvalue={{ value: email }}
          color="textPrimary"
          // style={{ maxWidth: '250px' }}
          oneLine
        />

        <ModalContainer>
          <MoreIconStyled onClick={() => setModalVisible(true)} />
          {modalVisible && (
            <ModalElem ref={ref}>
              <ModalItem onClick={handleUpdateVisible}>
                <EditIcon className="editIcon" />
                <TextElem tid="USER.UPDATE.MODAL.EDIT" />
              </ModalItem>
              <DividerElem />
              <ModalItem onClick={deleteModalOpen}>
                <DeleteIcon />
                <TextElem tid="COMMON.MODAL.BUTTON.BLOCK" color="error" />
              </ModalItem>
            </ModalElem>
          )}
        </ModalContainer>
      </Card>
      <UserItemDeleteContainer
        userId={id}
        open={deleteModalVisible}
        onClose={deleteModalClose}
      />
    </>
  );
};

const MoreIconStyled = styled(MoreIcon)`
  circle {
    fill: ${({ theme }) => theme[COLOR_ENUM.TEXT_SECONDARY]};
    transition: all 0.2s;
  }
  :hover {
    circle {
      fill: ${({ theme }) => theme[COLOR_ENUM.TEXT_THIRD]};
    }
  }
`;

const ModalContainer = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  height: 24px;
  margin-left: ${Spacing(4)};
`;

const ModalItem = styled.div`
  display: flex;
  gap: ${Spacing(2)};
  padding: ${Spacing(4)};

  svg {
    path {
      transition: all 0.3s;
    }
  }
  :first-child {
    border-radius: 9px 9px 0 0;
  }

  :last-child {
    border-radius: 0 0 9px 9px;
  }

  :hover {
    background: ${({ theme }) => theme[COLOR_ENUM.BORDER]};
    .editIcon {
      path {
        fill: ${({ theme }) => theme[COLOR_ENUM.TEXT_FOURTH]};
        stroke: transparent;
      }
    }
  }
`;

const ModalElem = styled.div`
  z-index: 9999;
  background-color: ${({ theme }) => theme[COLOR_ENUM.INPUT_ACTIVE]};
  top: 30px;
  right: 0;
  width: 180px;
  border-radius: ${SIZE_BORDER_RADIUS_DATA[SIZE_BORDER_RADIUS_ENUM.DEFAULT]}px;
  border: 1px solid ${({ theme }) => theme[COLOR_ENUM.BORDER]};

  position: absolute;

  border-bottom: 1px solid ${({ theme }) => theme[COLOR_ENUM.BORDER]};

  width: 180px;
  --height: auto;
  --box-shadow: none !important;
  --backdrop-opacity: 0;
`;

const Card = styled(CardElem)<{ height?: number; updVisible: boolean }>`
  display: grid;
  cursor: auto;
  grid-column: span 3;
  grid-template-columns: subgrid;
  gap: 0;
  justify-content: space-between;
  position: relative;
  align-items: center;
  ${({ height, updVisible }) => {
    if (updVisible) {
      return css`
        :hover {
          border: solid 1px transparent;
          background-color: transparent;
        }
        background-color: transparent;
        height: ${height}px;
      `;
    }
  }}
`;

const Div = styled.div`
  width: calc(100% + 2px);
  position: absolute;
  z-index: 999;
  top: -1px;
  left: -1px;
`;

export { Elem as UserItemElem };
